module.exports = __webpack_public_path__ + "img/shenwei.6c209835.jpg";